import { render, staticRenderFns } from "./trash.list.vue?vue&type=template&id=eccf4ae0&scoped=true&"
import script from "./trash.list.vue?vue&type=script&lang=js&"
export * from "./trash.list.vue?vue&type=script&lang=js&"
import style0 from "./trash.list.vue?vue&type=style&index=0&id=eccf4ae0&prod&scoped=true&lang=css&"
import style1 from "./trash.list.vue?vue&type=style&index=1&id=eccf4ae0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccf4ae0",
  null
  
)

export default component.exports